import React, { useRef, useState, useCallback } from "react";

const BeforeAfterSlider = ({ before, after, beforeLabel = "ANTES", afterLabel = "DESPUÉS" }) => {
  const containerRef = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const updateFromClientX = useCallback((clientX) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    let pct = ((clientX - rect.left) / rect.width) * 100;
    pct = Math.max(0, Math.min(100, pct));
    setPos(pct);
  }, []);

  const onPointerDown = (e) => {
    dragging.current = true;
    updateFromClientX(e.clientX);
  };
  const onPointerMove = (e) => {
    if (!dragging.current) return;
    updateFromClientX(e.clientX);
  };
  const stop = () => {
    dragging.current = false;
  };

  return (
    <div
      ref={containerRef}
      data-testid="before-after-slider"
      className="relative w-full aspect-[4/3] md:aspect-[16/10] select-none overflow-hidden border border-white/10 cursor-ew-resize bg-[#0a0a0a]"
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={stop}
      onPointerLeave={stop}
    >
      {/* After (full background) */}
      <img
        src={after}
        alt="Después"
        draggable={false}
        className="absolute inset-0 h-full w-full object-cover pointer-events-none"
      />
      <span className="absolute right-4 bottom-4 z-20 text-[10px] tracking-[0.25em] font-body bg-black/60 backdrop-blur px-3 py-1.5 border border-white/10 text-silver pointer-events-none">
        {afterLabel}
      </span>

      {/* Before (clipped) */}
      <div
        className="absolute inset-0 pointer-events-none overflow-hidden"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
      >
        <img
          src={before}
          alt="Antes"
          draggable={false}
          className="absolute inset-0 h-full w-full object-cover"
        />
        <span className="absolute left-4 bottom-4 text-[10px] tracking-[0.25em] font-body bg-black/60 backdrop-blur px-3 py-1.5 border border-white/10 text-gold">
          {beforeLabel}
        </span>
      </div>

      {/* Handle */}
      <div
        data-testid="before-after-drag-handle"
        className="absolute top-0 bottom-0 z-30 pointer-events-none"
        style={{ left: `${pos}%`, transform: "translateX(-50%)" }}
      >
        <div className="h-full w-px bg-gold/80" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-11 w-11 rounded-full border border-gold bg-black/70 backdrop-blur flex items-center justify-center shadow-[0_0_25px_rgba(212,175,55,0.5)]">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#d4af37" strokeWidth="2">
            <path d="M8 7l-5 5 5 5M16 7l5 5-5 5" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default BeforeAfterSlider;
